import { TaskType, Tenant } from '@legalzoom/constants';
import { ConsultationType } from './types';

export function getConsultationDescription(taskType: TaskType): string {
  switch (taskType) {
    case TaskType.AttorneyConsult1:
      return 'First launch consult';
    case TaskType.AttorneyConsult2:
      return 'Second launch consult';
    case TaskType.AttorneyConsult3:
      return 'Third launch consult';
    default:
      return '';
  }
}

export function getTenantForConsultationType(type: ConsultationType) {
  switch (type) {
    case ConsultationType.Tax:
    case ConsultationType.TaxPrep:
      return Tenant.TAX;
    case ConsultationType.Legal:
      return Tenant.LEGAL_PLANS;
    case ConsultationType.Fulfillment:
      return Tenant.FULFILLMENT;
    default:
      throw new Error(`No tenant defined for ConsultationType "${type}"`);
  }
}
